import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SharedDataService, ExtUsersService, ExtUser } from 'ngx-paf-common';

@Component({
  selector: 'app-folder-saved-info',
  templateUrl: './folder-saved-info.component.html',
  styleUrls: ['./folder-saved-info.component.scss']
})
export class FolderSavedInfoComponent implements  AfterViewInit {

  loggedUserId: string;
  supplierIdIfUnique:  number = 0;
  constructor(
    public sharedDataSvc: SharedDataService,
    private extUsersSvc:ExtUsersService) { 
  }
  ngAfterViewInit(): void {
    if (!this.sharedDataSvc.loggedExtUser){
      this.sharedDataSvc.loggedExtUserChange.subscribe(res=>{
        this.loadFromExtUser(res);
      });
    } else {
      this.loadFromExtUser(this.sharedDataSvc.loggedExtUser);
    }
  }


  loadFromExtUser(extUser:ExtUser):void{
    if (!extUser) return;
    this.loggedUserId=extUser.Email;
    this.extUsersSvc.getSuppliers(extUser.Id).subscribe(suppliers=>{
      if (suppliers.length==1){
        this.supplierIdIfUnique = suppliers[0].Id;
      } else {
        this.supplierIdIfUnique = 0;
      }
    });
  }

}
